import React from 'react';
import { FaSearch, FaSpinner } from 'react-icons/fa';

const SearchOrderForm = ({ 
    orderId, 
    setOrderId, 
    handleSearch, 
    loading, 
    language 
}) => {
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                {language === 'ar' ? 'رقم الطلب' : 'Order Number'}
            </label>
            <div className="flex space-x-2 rtl:space-x-reverse">
                <input
                    type="text"
                    value={orderId}
                    onChange={(e) => setOrderId(e.target.value)}
                    onKeyPress={handleKeyPress}
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    placeholder={language === 'ar' ? 'ادخل رقم الطلب' : 'Enter order number'}
                    disabled={loading}
                />
                <button
                    onClick={handleSearch}
                    disabled={loading || !orderId.trim()}
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                >
                    {loading ? (
                        <FaSpinner className="animate-spin h-5 w-5" />
                    ) : (
                        <>
                            <FaSearch className={language === 'ar' ? 'ml-2' : 'mr-2'} />
                            {language === 'ar' ? 'بحث' : 'Search'}
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default SearchOrderForm;
